import React, { useState, useRef } from 'react';
import { GoChevronRight } from "react-icons/go";

const CourseList = () => {
    return (
        <>
            <section id='course'>
                <div className="container">
                    <h2 className='title'>Our Course</h2>
                    <p className="desc">Expert-led courses for comprehensive language proficiency and standardized test preparation</p>
                    <div className="courseListMain">
                        <div className="courseListBox">
                            <h3>OET</h3>
                            <p>Your key to unlocking a rewarding healthcare career abroad.</p>
                        </div>
                        <div className="courseListBox">
                            <h3>IELTS</h3>
                            <p>Unlock a world of academic and professional opportunities with a strong IELTS score.</p>
                        </div>
                        <div className="courseListBox">
                            <h3>NCLEX-RN</h3>
                            <p>Master the NCLEX-RN and pursue your international nursing goals.</p>
                            {/* <a href="https://studyingdynamic.com/mocktest/user/" target='_blank'>Open <GoChevronRight /></a> */}
                        </div>
                        <div className="courseListBox">
                            <h3>German</h3>
                            <p>Expand your career horizons with German language proficiency.</p>
                        </div>
                        <div className="courseListBox">
                            <h3>CBT</h3>
                            <p>Start Your CBT Journey and Take Your Nursing Career to the Next Level.</p>
                        </div>
                        <div className="courseListBox">
                            <h3>PTE</h3>
                            <p>Achieve nursing excellence with a superior PTE score.</p>
                        </div>
                        <div className="courseListBox">
                            <h3>TOEFL</h3>
                            <p>TOEFL measures English skills for academic and professional global success.</p>
                        </div>
                        <div className="courseListBox">
                            <h3>Digital Marketing</h3>
                            <p>Advance your Career with our Comprehensive Digital Marketing Course.</p>
                        </div>
                        <div className="courseListBox">
                            <h3>Trading</h3>
                            <p>Accelerate Your Financial Growth with Our Trading Course.</p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default CourseList;